import { render } from "./host.vue?vue&type=template&id=62a0aa15&scoped=true"
import script from "./host.vue?vue&type=script&lang=js"
export * from "./host.vue?vue&type=script&lang=js"

import "./host.vue?vue&type=style&index=0&id=62a0aa15&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a0aa15"]])

export default __exports__